/* 
 * DESIGN: "Leśna Przystań" — Google Reviews section
 * Real Google reviews from Kajaki Kudłaty Cooky
 */
import { useState } from "react";
import { Star, ChevronLeft, ChevronRight, ExternalLink } from "lucide-react";

const reviews = [
  {
    id: 2,
    name: "Sebastian",
    avatar: "SE",
    rating: 5,
    date: "2 tygodnie temu",
    badge: "Nowa",
    text: "Najlepsza ekipa nad Pilicą! Konkurencja za płotem 🙂, może się uczyć 😉💪. Jeśli planujecie spływ Pilicą, to tylko tutaj. Właściciele robią mega robotę – widać, że to ich pasja, a nie tylko biznes. Od samego wejścia czuć super klimat.",
    verified: true,
  },
  {
    id: 3,
    name: "K.T.",
    avatar: "KT",
    rating: 5,
    date: "2 tygodnie temu",
    badge: "Nowa",
    text: "Pierwsza klasa...rezerwacja od ręki bezproblemowo, właściciele bardzo pomocni, kajaki czyściutkie...mimo że to był pierwszy raz to na pewno tam wrócę 😀",
    verified: true,
  },
  {
    id: 4,
    name: "Oliwia Płońska",
    avatar: "OP",
    rating: 5,
    date: "10 miesięcy temu",
    text: "Mieliśmy ogromną przyjemność skorzystać z oferty Kajaki Kudłaty Cookie i… to była petarda! 🚣‍♀️🔥 Od początku do końca wszystko zorganizowane na najwyższym poziomie – profesjonalnie, ale z luzem i uśmiechem, który udzielał się każdemu.",
    verified: true,
    likes: 3,
  },
  {
    id: 5,
    name: "Andrzej Kepka",
    avatar: "AK",
    rating: 5,
    date: "9 miesięcy temu",
    isGuide: true,
    text: "Kajaki zadbane, nowe i czyste. Rewelacyjne miejsce na biwak, można rozpalić ognisko, drewno jest dostępne nieodpłatnie. Jest wiata która zapewnia ochronę przed deszczem. Dostępne WC oraz bieżąca woda. Miejsce zaledwie 1,5km od centrum.",
    verified: true,
    likes: 2,
  },
  {
    id: 6,
    name: "Maciej Zdonek",
    avatar: "MZ",
    rating: 5,
    date: "9 miesięcy temu",
    text: "Bardzo pozytywni ludzie, z pasją oraz poczuciem humoru. Doskonały serwis i czas reakcji. Kajaki bardzo dobrej jakości, które świetnie sobie radzą nawet na mieliznach. Mimo niskiego stanu wody na trasie z Zakościela do Domaniewic nie przepychaliśmy kajaków.",
    verified: true,
  },
  {
    id: 7,
    name: "Lukasz Olejnik",
    avatar: "LO",
    rating: 5,
    date: "10 miesięcy temu",
    text: "Świetna wypożyczalnia kajaków, sprawna i przemiła obsługa. Nowe kajaki w doskonałym stanie. Bezproblemowy szybki odbiór.",
    verified: true,
    likes: 3,
  },
  {
    id: 8,
    name: "Kierat09",
    avatar: "KI",
    rating: 5,
    date: "8 miesięcy temu",
    text: "Polecam z całego serca, pełen profesjonalizm i zaangażowanie ze strony właścicieli. Kajaki oraz kapoki czyste i zadbane. Dodatkowym plusem jest możliwość spływu ze swoim czworonożnym przyjacielem. Na pewno wrócę w przyszłym roku :)",
    verified: true,
  },
  {
    id: 9,
    name: "Konrad Groszewski",
    avatar: "KG",
    rating: 5,
    date: "9 miesięcy temu",
    text: "Fachowość w każdym calu, obsługa miła i pomocna, wszystko dopięte na ostatni guzik. Gorąco polecam!",
    verified: true,
    likes: 2,
  },
  {
    id: 10,
    name: "Magdalena M",
    avatar: "MM",
    rating: 5,
    date: "8 miesięcy temu",
    text: "Gorąco polecam 🥰 Kajaki czyste i zadbane, obsługa bardzo miła i pomocna. Dużym plusem jest możliwość ogniska po spływie kajakowym. Pełen profesjonalizm 🥰",
    verified: true,
  },
  {
    id: 11,
    name: "Kinga Jagiełło",
    avatar: "KJ",
    rating: 5,
    date: "10 miesięcy temu",
    text: "Spływ kajakowy u Was to cudowne doświadczenie. Piękne widoki, wspaniała obsługa. A największym plusem jest to, że spływ można zakończyć na Waszej działce, rozpalić ognisko i posiedzieć pod altanką. Pięknie dziękujemy! ❤️",
    verified: true,
    likes: 3,
  },
  {
    id: 12,
    name: "Ewa Banaszczak",
    avatar: "EB",
    rating: 5,
    date: "9 miesięcy temu",
    isGuide: true,
    text: "Polecamy! Świetna lokalizacja, super kontakt z właścicielami, korzystamy regularnie :)",
    verified: true,
  },
  {
    id: 13,
    name: "Nina Mierzejewska",
    avatar: "NM",
    rating: 5,
    date: "9 miesięcy temu",
    text: "Super organizacja, przesympatyczna obsługa, wszystko sprawnie i na czas, czyste kajaki, miejsce gdzie można przebrać się po spływie, przy większej grupie jest opcja ogniska lub grilla. Polecam serdecznie",
    verified: true,
    likes: 2,
  },
  {
    id: 14,
    name: "tomasz kulawinski",
    avatar: "TK",
    rating: 5,
    date: "9 miesięcy temu",
    isGuide: true,
    text: "Bardzo udany spływ od Spały do Zakościela, przemiły i bardzo pomocny właściciel - gorąco polecam 👍♥️",
    verified: true,
    likes: 3,
  },
  {
    id: 15,
    name: "Olga Olejnik",
    avatar: "OO",
    rating: 5,
    date: "10 miesięcy temu",
    text: "Przesympatyczni właściciele, którzy dbają o komfort i bezpieczeństwo każdego klienta. Podczas spływu cisza, spokój i piękne krajobrazy!!! Polecam",
    verified: true,
    likes: 1,
  },
  {
    id: 16,
    name: "Anna Jagiello",
    avatar: "AJ",
    rating: 5,
    date: "10 miesięcy temu",
    text: "Serdecznie polecam, piękne nowe Kajaki wspaniała przygoda a po spływie ognisko i mile spędzony czas na łonie natury",
    verified: true,
    likes: 2,
  },
  {
    id: 17,
    name: "Alicja prasał",
    avatar: "AP",
    rating: 5,
    date: "10 miesięcy temu",
    text: "Polecam!!! Bardzo miła obsługa. Nie ma kolejek przez co nie czeka się na wypłynięcie. Zaletą jest również możliwość zabrania zwierzątka.",
    verified: true,
    likes: 3,
  },
  {
    id: 18,
    name: "Jan Kośliński",
    avatar: "JK",
    rating: 5,
    date: "3 dni temu",
    badge: "Nowa",
    text: "Super ludzie, byliśmy na spływie wraz ze znajomymi i jesteśmy bardzo zadowoleni z obsługi jakiej doświadczyliśmy",
    verified: true,
  },
  {
    id: 19,
    name: "zuzankka",
    avatar: "ZU",
    rating: 5,
    date: "tydzień temu",
    badge: "Nowa",
    text: "Super trasa, piękne widoki, kochana i profesjonalna obsługa!",
    verified: true,
  },
  {
    id: 20,
    name: "Zwariowane Z i J",
    avatar: "ZJ",
    rating: 5,
    date: "tydzień temu",
    badge: "Nowa",
    text: "Super miejsce i klimat, polecam każdemu :))",
    verified: true,
  },
  {
    id: 21,
    name: "Ilona Zanijat",
    avatar: "IZ",
    rating: 5,
    date: "10 miesięcy temu",
    text: "Z całego serca polecam! Super obsługa i przemiła atmosfera. Sprzęt w świetnym stanie, bardzo dobrze przygotowany i zadbany.",
    verified: true,
    likes: 2,
  },
  {
    id: 22,
    name: "Jolanta Krasnodębska",
    avatar: "JKR",
    rating: 5,
    date: "9 miesięcy temu",
    text: "Bardzo polecamy!!! Miła obsługa, łatwy kontakt. Nowe kajaki i czyste kapoki. Super :)",
    verified: true,
  },
  {
    id: 23,
    name: "Krystyna Marekwia",
    avatar: "KM",
    rating: 5,
    date: "9 miesięcy temu",
    text: "Obsługa rewelacja. Kajaki czyste, zadbane. Gorąco polecam 🙂",
    verified: true,
  },
  {
    id: 24,
    name: "Antoni Charążka",
    avatar: "AC",
    rating: 5,
    date: "10 miesięcy temu",
    text: "Świetna obsługa, widoki są cudowne, a atmosfera wyśmienita polecam 😎😎",
    verified: true,
    likes: 2,
  },
  {
    id: 25,
    name: "Mateusz Sygitowicz",
    avatar: "MS",
    rating: 5,
    date: "9 miesięcy temu",
    text: "Wypożyczalnia kajaków na najwyższym poziomie, kajaki czyste, odbiór natychmiastowy. Polecam",
    verified: true,
    likes: 2,
  },
  {
    id: 26,
    name: "13cm na flaku",
    avatar: "CF",
    rating: 5,
    date: "9 miesięcy temu",
    text: "Polecam kajaki u Kudłatego bardzo mili ludzie, świetna atmosfera, kajaki super zadbane. Wszystko było lux 5/5",
    verified: true,
    likes: 1,
  },
];

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={star}
          size={16}
          className={star <= rating ? "star-filled fill-current" : "text-gray-300"}
        />
      ))}
    </div>
  );
}

function ReviewCard({ review }: { review: typeof reviews[0] }) {
  const [expanded, setExpanded] = useState(false);
  const isLong = review.text.length > 160;
  const displayText = isLong && !expanded ? review.text.slice(0, 160) + "…" : review.text;

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 card-hover h-full flex flex-col">
      {/* Header */}
      <div className="flex items-start gap-3 mb-4">
        <div
          className="w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0"
          style={{ background: "oklch(0.32 0.08 155)", fontFamily: "'Outfit', sans-serif" }}
        >
          {review.avatar.slice(0, 2)}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="font-semibold text-gray-900 text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>
              {review.name}
            </span>
            {review.badge && (
              <span
                className="text-[10px] px-1.5 py-0.5 rounded font-bold"
                style={{ background: "oklch(0.55 0.18 45)", color: "white", fontFamily: "'JetBrains Mono', monospace" }}
              >
                {review.badge}
              </span>
            )}
            {review.isGuide && (
              <span
                className="text-[10px] text-gray-600"
                style={{ fontFamily: "'JetBrains Mono', monospace" }}
              >
                Lokalny przewodnik
              </span>
            )}
            {review.verified && (
              <span
                className="text-xs text-green-600 font-medium"
                style={{ fontFamily: "'JetBrains Mono', monospace" }}
              >
                ✓
              </span>
            )}
          </div>
          <div className="flex items-center gap-2 mt-0.5">
            <StarRating rating={review.rating} />
            <span className="text-xs text-gray-600" style={{ fontFamily: "'Outfit', sans-serif" }}>
              {review.date}
            </span>
          </div>
        </div>
        {/* Google icon */}
        <svg viewBox="0 0 24 24" className="w-5 h-5 flex-shrink-0 opacity-60" fill="none">
          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
        </svg>
      </div>

      {/* Review text */}
      <p className="text-gray-600 text-sm leading-relaxed flex-1" style={{ fontFamily: "'Outfit', sans-serif" }}>
        "{displayText}"
        {isLong && (
          <button
            onClick={() => setExpanded(!expanded)}
            className="ml-1 font-semibold hover:underline"
            style={{ color: "oklch(0.45 0.18 45)" }}
          >
            {expanded ? "Zwiń" : "Więcej"}
          </button>
        )}
      </p>

      {review.likes && (
        <div className="mt-3 pt-3 border-t border-gray-50 flex items-center gap-1">
          <span className="text-xs text-gray-600" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
            ❤️ {review.likes}
          </span>
        </div>
      )}
    </div>
  );
}

export default function ReviewsSection() {
  const [page, setPage] = useState(0);
  const perPage = 3;
  const totalPages = Math.ceil(reviews.length / perPage);
  const visibleReviews = reviews.slice(page * perPage, page * perPage + perPage);

  return (
    <section
      className="py-20 px-4"
      style={{ background: "oklch(0.93 0.03 85)" }}
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="section-tag justify-center mb-3">
            <span>Opinie klientów</span>
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold mb-4"
            style={{ fontFamily: "'Playfair Display', serif", color: "oklch(0.22 0.06 155)" }}
          >
            Co mówią nasi <em className="italic" style={{ color: "oklch(0.45 0.18 45)" }}>klienci</em>
          </h2>
          {/* Google rating summary */}
          <div className="flex items-center justify-center gap-3 mb-2">
            <div className="flex gap-0.5">
              {[1,2,3,4,5].map(s => (
                <Star key={s} size={24} className="star-filled fill-current" />
              ))}
            </div>
            <span
              className="text-3xl font-bold"
              style={{ fontFamily: "'Playfair Display', serif", color: "oklch(0.22 0.06 155)" }}
            >
              5.0
            </span>
            <span className="text-gray-600 text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>
              w Google Reviews
            </span>
          </div>
          <p className="text-gray-600 text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>
            125+ opinii od zadowolonych klientów
          </p>
        </div>

        {/* Reviews grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {visibleReviews.map((review) => (
            <ReviewCard key={review.id} review={review} />
          ))}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex items-center justify-center gap-3">
            <button
              onClick={() => setPage(Math.max(0, page - 1))}
              disabled={page === 0}
              aria-label="Poprzednia strona opinii"
              className="p-2 rounded-full border border-gray-200 hover:border-[oklch(0.45_0.18_45)] disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
              <ChevronLeft size={20} aria-hidden="true" />
            </button>
            <span
              className="text-sm text-gray-600"
              style={{ fontFamily: "'JetBrains Mono', monospace" }}
            >
              {page + 1} / {totalPages}
            </span>
            <button
              onClick={() => setPage(Math.min(totalPages - 1, page + 1))}
              disabled={page === totalPages - 1}
              aria-label="Następna strona opinii"
              className="p-2 rounded-full border border-gray-200 hover:border-[oklch(0.45_0.18_45)] disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
              <ChevronRight size={20} aria-hidden="true" />
            </button>
          </div>
        )}

        {/* CTA to Google */}
        <div className="text-center mt-8">
          <a
            href="https://www.google.com/maps/search/Kajaki+Kudłaty+Cooky+Zakościele"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-[oklch(0.45_0.18_45)] transition-colors"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            <ExternalLink size={14} />
            Przeczytaj wszystkie opinie w Google
          </a>
        </div>
      </div>
    </section>
  );
}
